export const GET_SEA_REQUEST = "@@ddw.herdnet.sandbox.hnadvice/GET_SEA_REQUEST";
export const GET_SEA_SUCCESS = "@@ddw.herdnet.sandbox.hnadvice/GET_SEA_SUCCESS";
export const GET_SEA_FAILURE = "@@ddw.herdnet.sandbox.hnadvice/GET_SEA_FAILURE";
